@if (
  {
    enableNewShiftDropZone:
      createNewViaDragAndDropService.showEmptyShiftDropZone$ | async,
    enableShiftTemplateDropZone:
      createNewViaDragAndDropService.showShiftTemplateDropZone$ | async,
    enableNewAbsenceDropZone:
      createNewViaDragAndDropService.enableNewAbsenceDropZone$ | async,
    showShiftDropZone: dragAndDropModeService.showShiftDropZone$ | async,
    isMoveMode: dragAndDropModeService.isMoveMode$ | async,
    isAssignmentMode: dragAndDropModeService.isAssignmentMode$ | async,
    loadingIds: createNewViaDragAndDropService.updatingIds$ | async,
    draggingShift: dragAndDropModeService.draggingShiftV2$ | async,
    enableActivityDropZone:
      dragAndDropModeService.showActivityDropZone$ | async,
    userId: activityDropZoneHelperService.userId$ | async,
    enableNewActivityShiftDropZone:
      createNewViaDragAndDropService.showNewActivityShiftDropZone$ | async,
    enableMoveActivityDropZone:
      dragAndDropModeService.showMoveActivityDropZone$ | async,
    enableSnappingMode:
      mouseMovementHelperService.isUserDraggingActivity$ | async,
    activity: activityDropZoneHelperService.activity$ | async,
    staffLayoutStyle: staffLayoutStyle$ | async,
  };
  as data
) {
  <div
    #rowContainer
    [style.height.px]="defaultRowHeight"
    [attr.data-test-id]="'wilson-timeline-user-row-shifts-v2:row-' + user.id"
    (contextmenu)="contextMenu($event, menu, rowContainer)"
  >
    @if (
      {
        rowPadding: ROW_PADDING,
      };
      as styleData
    ) {
      @if (data.enableNewAbsenceDropZone) {
        <wilson-new-absence-drop-zone
          [userId]="user.id"
        ></wilson-new-absence-drop-zone>
      }
      @if (data.enableActivityDropZone && user.id !== data?.userId) {
        <wilson-activity-drop-zone-v2
          [userId]="user.id"
        ></wilson-activity-drop-zone-v2>
      }
      @if (data.enableNewActivityShiftDropZone) {
        <wilson-new-shift-from-empty-activity-drop-zone
          [userId]="user.id"
        ></wilson-new-shift-from-empty-activity-drop-zone>
      }
      @if (data.enableActivityDropZone || data.enableMoveActivityDropZone) {
        <wilson-activity-reset-drop-zone></wilson-activity-reset-drop-zone>
      }
      @if (data.enableMoveActivityDropZone) {
        <wilson-activity-move-drop-zone-v2
          [userId]="user.id"
          [shift]="dropZoneShiftView?.shift"
        ></wilson-activity-move-drop-zone-v2>
      }
      @if (data.enableSnappingMode) {
        <wilson-activity-snap-line-v2
          [userId]="user.id"
          [shiftView]="dropZoneShiftView"
        ></wilson-activity-snap-line-v2>
      }
      @if (data.activity) {
        <wilson-activity-gap-fill-animation
          [userId]="user.id"
        ></wilson-activity-gap-fill-animation>
      }
      @if (!data.isMoveMode && data.draggingShift && data.showShiftDropZone) {
        <wilson-assign-shift-drop-zone-v2
          [userId]="user.id"
        ></wilson-assign-shift-drop-zone-v2>
      }
      @if (data.enableNewShiftDropZone) {
        <wilson-new-shift-drop-zone-v2
          [userId]="user.id"
        ></wilson-new-shift-drop-zone-v2>
      }
      @if (data.enableShiftTemplateDropZone) {
        <wilson-shift-template-drop-zone-v2
          [userId]="user.id"
        ></wilson-shift-template-drop-zone-v2>
      }
      @let userDataRows = (userDataRowsSubject | async) || [];
      <ng-container
        *rxFor="
          let innerRowItem of userDataRows;
          let innerRowIndex = index;
          let isLastUser = last;
          trackBy: trackByUserRows
        "
      >
        @let isClusteredRow = innerRowIndex === 2;
        @let innerRowHeight =
          {
            numberOfInnerRows: userDataRows.length || 1,
            defaultRowHeight: defaultRowHeight ?? 1,
            currentInnerRowIndex: innerRowIndex,
          } | timelineInnerRowDynamicHeight;
        @let itemHeight =
          innerRowHeight
            | wilsonTimelineShiftHeight
              : userDataRows.length
              : defaultRowHeight ?? 1;
        <div
          #innerRow
          class="inner-row"
          [ngStyle]="{
            'min-height': innerRowHeight + 'px',
            'padding-top': styleData.rowPadding + 'px',
            'padding-bottom':
              isLastUser || isClusteredRow ? styleData.rowPadding + 'px' : 0,
          }"
          (contextmenu)="contextMenu($event, menu, innerRow)"
          [attr.data-test-id]="
            'wilson-timeline-user-row-shifts-v2:row-' +
            user.id +
            ':inner-row-' +
            innerRowIndex
          "
        >
          @let isMinimalHeight =
            data.staffLayoutStyle === StaffLayoutStyle.Minimal;
          @if (!isClusteredRow) {
            @if (innerRowItem.shifts.length > 0) {
              <div class="d-flex">
                <!-- TODO: track by shift ids and activity ids (when show activities is present) This will help with the case when there are no changes to a component -->
                <ng-container *rxFor="let shiftView of innerRowItem.shifts">
                  @if (
                    data.enableActivityDropZone &&
                    shiftView.shift.id !== data.activity?.shiftId &&
                    shiftView.shift.id !== MOCK_SHIFT_ID
                  ) {
                    <wilson-activity-shift-drop-zone-v2
                      [userId]="user.id"
                      [shiftView]="shiftView"
                      [isDropAllowed]="shiftView.shift | isShiftDraggable"
                    ></wilson-activity-shift-drop-zone-v2>
                  }
                  @if (
                    data.enableNewActivityShiftDropZone &&
                    shiftView.shift.id !== MOCK_SHIFT_ID
                  ) {
                    <wilson-add-empty-activity-to-shift-drop-zone
                      [userId]="user.id"
                      [shiftId]="shiftView.shift.id"
                      [isDropAllowed]="shiftView.shift | isShiftDraggable"
                    ></wilson-add-empty-activity-to-shift-drop-zone>
                  }
                </ng-container>
                <!-- TODO:get is shift has clusterId to determine if its being overlapped -->
                <!-- This is the point to inject the main value for overlap -->
                <wilson-timeline-auto-size-user-shifts-v2
                  *rxFor="
                    let shiftView of innerRowItem.shifts;
                    let isLastShiftInRow = last;
                    trackBy: trackByShiftViewDetails
                  "
                  [shiftView]="shiftView"
                  [userId]="user.id!"
                  [showShiftValidation]="true"
                  [draggingItemId]="
                    dragAndDropModeService.draggingItemId$ | async
                  "
                  [updatingShiftIds]="data.loadingIds || []"
                  [isCursorGrab]="true"
                  [isActivityDraggable]="true"
                  [numberOfInnerRows]="userDataRows.length"
                  [innerRowIndex]="innerRowIndex"
                  [shiftHeight]="itemHeight"
                  [isLastShiftInLastUserRow]="isLastUser && isLastShiftInRow"
                  (selectActivityEvent)="
                    openActivityDrawer($event, user.id || null)
                  "
                ></wilson-timeline-auto-size-user-shifts-v2>
              </div>
            }
            @let timelineCards =
              (innerRowItem | toDateTimeRangeV2: user | async) || [];
            <wilson-gantt-chart-time-difference
              [user]="user!"
              [timelineCards]="timelineCards"
              [shiftsStayInRange]="
                timelineStaysSuggestionService.shiftsRecommendedStaysInRangeMap$
                  | async
              "
              [firstUserDataRowShifts]="innerRowItem.shifts"
              [firstUserDataRowStays]="innerRowItem.stays"
              [canRenderStay]="
                !!(timelineStaysSuggestionService.canRenderStays$ | async)
              "
              [showAddTransferButton]="true"
              [isLineVisible]="
                userIndex === mouseOverRowIndex &&
                !!(dragAndDropModeService.showTimeDifference$ | async)
              "
              (addTransfer)="
                openTransferModal(userDataRows[0].shifts, timelineCards, $event)
              "
              (addStaysClicked)="
                openStaysDrawer({
                  shiftViews: userDataRows[0].shifts,
                  index: $event,
                  timelineCards,
                })
              "
              (singleShiftCreateStay)="
                openStayDrawerWithSingleShift(userDataRows[0].shifts, $event)
              "
              [isMinimalHeight]="isMinimalHeight"
            ></wilson-gantt-chart-time-difference>
            @if (innerRowItem.absences.length > 0) {
              <wilson-timeline-user-absence
                [absences]="innerRowItem.absences | toAbsenceData"
                (openDrawer)="openAbsenceDrawer($event)"
                [loadingAbsenceIds]="data.loadingIds || []"
                [isOverlapDetected]="userDataRows.length > 1"
                [absenceHeight]="itemHeight"
                [draggingAsenceId]="
                  dragAndDropModeService.draggingItemId$ | async
                "
              ></wilson-timeline-user-absence>
            }
            @if (innerRowItem.stays.length > 0) {
              <wilson-timeline-user-stays
                [stayViews]="innerRowItem.stays"
                [isOverlapDetected]="userDataRows.length > 1"
                [itemHeight]="
                  innerRowHeight > (defaultRowHeight ?? 1) / 3
                    ? STAY_CARD_DEFAULT_HEIGHT
                    : itemHeight
                "
                (openEditStayDrawer)="editStayDrawer($event)"
              ></wilson-timeline-user-stays>
            }
          } @else {
            @let adjustedItemHeight =
              itemHeight - CLUSTER_CARD_HEIGHT_ADJUSTMENT;
            @if (innerRowItem.shifts.length > 0) {
              <div>
                <ng-container *rxFor="let shift of innerRowItem.shifts">
                  <ng-container
                    *ngTemplateOutlet="
                      deferredClusterCardHelperService.getClusterTemplate();
                      context: {
                        item: shift,
                        isMinimalHeight: isMinimalHeight,
                        clusterMenu: clusterMenu,
                        onClick: getClusterForSelectedItem.bind(this),
                        height: adjustedItemHeight,
                      }
                    "
                  ></ng-container>
                </ng-container>
              </div>
            }
            @if (innerRowItem.absences.length > 0) {
              <div>
                <ng-container *rxFor="let absence of innerRowItem.absences">
                  <ng-container
                    *ngTemplateOutlet="
                      deferredClusterCardHelperService.getClusterTemplate();
                      context: {
                        item: absence,
                        isMinimalHeight: isMinimalHeight,
                        clusterMenu: clusterMenu,
                        onClick: getClusterForSelectedItem.bind(this),
                        height: adjustedItemHeight,
                      }
                    "
                  ></ng-container>
                </ng-container>
              </div>
            }
            @if (innerRowItem.stays.length > 0) {
              <div>
                <ng-container *rxFor="let stay of innerRowItem.stays">
                  <ng-container
                    *ngTemplateOutlet="
                      deferredClusterCardHelperService.getClusterTemplate();
                      context: {
                        item: stay,
                        isMinimalHeight: isMinimalHeight,
                        clusterMenu: clusterMenu,
                        onClick: getClusterForSelectedItem.bind(this),
                        height: adjustedItemHeight,
                      }
                    "
                  ></ng-container>
                </ng-container>
              </div>
            }
            <nz-dropdown-menu #clusterMenu="nzDropdownMenu">
              @let hasAbsenceUpdatePermissions =
                can(RoleAction.Update, RolePermissionSubject.Absence);
              @let hasShiftUpdatePermissions =
                can(RoleAction.Update, RolePermissionSubject.Shift);
              @let isShiftDraggableFeatureFlag =
                !!(
                  'portal-shift-timeline-shift-drag-drop'
                  | featureFlagPure
                  | async
                );
              @if (cluster) {
                <ul nz-menu>
                  <ng-container *rxFor="let shiftView of cluster.shifts">
                    @let leftPx =
                      shiftView.accurateStartDateTime
                        | ganttStartingPixel
                        | async;
                    @let rightPx =
                      [
                        shiftView.accurateStartDateTime,
                        shiftView.accurateEndDateTime,
                      ]
                        | ganttEndingPixel
                        | async;
                    @let calculatedShiftWidth =
                      { left: leftPx, right: rightPx || 0 }
                        | timeDifferenceWidthPx
                        | async;
                    @let shiftRenderDatetime =
                      shiftView.shift | determineShiftRenderDatetime;
                    @let shiftStartDetail = shiftRenderDatetime.startDatetime;
                    @let shiftEndDetail = shiftRenderDatetime.endDatetime;
                    <wilson-shift-validation-tooltip-wrapper
                      [attr.data-test-id]="
                        'wilson-timeline-user-row-shifts-v2:shift-validation-tooltip-wrapper' +
                        shiftView.shift.name
                      "
                      [showShiftValidation]="true"
                      [plannedShiftStartDateTime]="
                        shiftView.shift.startDatetime
                      "
                      [plannedShiftEndDateTime]="shiftView.shift.endDatetime"
                      [accurateShiftStartDateTime]="shiftStartDetail.date"
                      [accurateShiftEndDateTime]="shiftEndDetail.date"
                      [shiftStartTimeDifference]="
                        shiftStartDetail.timeDifference
                      "
                      [shiftEndTimeDifference]="shiftEndDetail.timeDifference"
                      [shiftStartTimeType]="shiftStartDetail.type"
                      [shiftEndTimeType]="shiftEndDetail.type"
                      [plannedStartLocation]="
                        shiftView.shift.startLocation || null
                      "
                      [plannedEndLocation]="shiftView.shift.endLocation || null"
                      [reportedStartLocation]="
                        shiftView.shift.reportedStartLocation || null
                      "
                      [reportedEndLocation]="
                        shiftView.shift.reportedEndLocation || null
                      "
                      [displayTooltip]="true"
                      [tooltipPlacement]="'left'"
                    >
                      <li
                        nz-menu-item
                        [draggable]="
                          isShiftDraggableFeatureFlag &&
                          (shiftView.shift | isShiftDraggable)
                        "
                        wilsonTimelineRowDragHandlerV2
                        [shift]="shiftView.shift"
                        [hasShiftUpdatePermissions]="
                          !!hasShiftUpdatePermissions
                        "
                        [isMoveMode]="data.isMoveMode"
                        [isAssignmentMode]="data.isAssignmentMode"
                        [calculatedShiftWidth]="calculatedShiftWidth"
                        (mouseenter)="
                          shiftCardTooltipStateService.initState(
                            user.id,
                            shiftView.shift
                          )
                        "
                        (click)="
                          checkShiftKeyOnClick(
                            $event,
                            shiftView.shift.id,
                            undoTemplate
                          )
                        "
                      >
                        {{ shiftView.shift.name }}
                      </li>
                    </wilson-shift-validation-tooltip-wrapper>
                  </ng-container>
                  <ng-container *rxFor="let absenceView of cluster.absences">
                    <li
                      nz-menu-item
                      nz-tooltip
                      [nzTooltipTitle]="absenceTooltip"
                      [nzTooltipPlacement]="'left'"
                      [nzTooltipMouseEnterDelay]="0.3"
                      [nzTooltipOverlayStyle]="{
                        'max-width': '450px',
                        'min-width': '250px',
                      }"
                      (click)="
                        openAbsenceDrawer({
                          left: null,
                          right: null,
                          id: absenceView.absence.id,
                        })
                      "
                      [draggable]="data.isMoveMode"
                      (dragstart)="
                        clusterDragHelperService.startDragAbsence(
                          $event,
                          null,
                          null,
                          absenceView.absence,
                          !!hasAbsenceUpdatePermissions
                        )
                      "
                      (dragend)="
                        clusterDragHelperService.dragEndAbsence(
                          !!data.isMoveMode
                        )
                      "
                      (drag)="
                        hasAbsenceUpdatePermissions &&
                          data.isMoveMode &&
                          clusterDragHelperService.trackHorizontalDragAbsence(
                            $event,
                            null,
                            null,
                            null
                          )
                      "
                    >
                      {{
                        absenceView.absence
                          | getAbsenceTimelineCardTitle
                          | async
                      }}
                    </li>
                    <ng-template #absenceTooltip>
                      <wilson-timeline-absence-tooltip
                        [absence]="absenceView.absence"
                      >
                      </wilson-timeline-absence-tooltip>
                    </ng-template>
                  </ng-container>
                  <li
                    nz-menu-item
                    *rxFor="let stayView of cluster.stays"
                    (click)="
                      editStayDrawer({
                        left: null,
                        right: null,
                        stay: stayView.stay,
                      })
                    "
                  >
                    {{
                      'page.shift_timeline.hotel_stay.drawer.form.accomodation_type.' +
                        stayView.stay.type | translate
                    }}
                    -
                    {{
                      'page.stays.status.' + stayView.stay.status | translate
                    }}
                  </li>
                </ul>
              } @else {
                <ul nz-menu class="p-3">
                  <nz-skeleton
                    [nzActive]="true"
                    [nzTitle]="false"
                    [nzParagraph]="{ rows: 3 }"
                  ></nz-skeleton>
                </ul>
              }
            </nz-dropdown-menu>
            <ng-template #undoTemplate>
              <wilson-nz-message-timer-line [duration]="MESSAGE_DURATION">
                <wilson-message-with-undo-option></wilson-message-with-undo-option>
              </wilson-nz-message-timer-line>
            </ng-template>
          }
        </div>
      </ng-container>
    }
  </div>
}

<nz-dropdown-menu #menu="nzDropdownMenu">
  <wilson-timeline-user-row-context-menu-wrapper></wilson-timeline-user-row-context-menu-wrapper>
</nz-dropdown-menu>
